import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/pt-br'

// methods
function getEditionStatusBadge (status) {
  return status === 'open' ? 'success'
        : status === 'published' ? 'success'
        : status === 'rejected' ? 'danger'
        : status === 'cancelled' ? 'danger': 'primary'
}

function translateEditionStatusBadge (status) {
  return status === 'open' ? 'Aberta para Envio'
        : status === 'review' ? 'Em Revisão - Aguardando Moderadores'
        : status === 'generate' ? 'Fechada - Em processo de confecção'
        : status === 'accepted' ? 'Diagramada - Pronta para publicação'
        : status === 'scheduled' ? 'Pronta - Publicação agendada'
        : status === 'rejected' ? 'Rejeitada'
        : status === 'cancelled' ? 'Cancelada'
        : status === 'published' ? 'Publicada' : ''
}

// filters
function formatDate (value) {
  if (value) {
    return moment.utc(String(value)).format('LL')
  }

  return '-'
}

function formateDateLong (value) {
  if (value) {
    return moment(String(value)).format('LLL')
  }

  return '-'
}

function returnBoolean (value) {
  if (value && value == '1') {
    return 'Sim'
  }
  else {
    return 'Não'
  }
}

function formatEdition (value) {
  if (!value) {
    return '-'
  }

  if (!value.edition_type) {
    return '-'
  }

  let label = value.edition_type.name + ' n. ' + value.number

  if (value.suplement === 1 || value.suplement === '1') {
    label = label + ' - Sup.'
  }

  return label + ' de ' + moment.utc(value.publication_date).format('LL')
}

function formatEditionAbreviation (value) {
  if (!value) {
    return '-'
  }

  if (!value.edition_type) {
    return '-'
  }

  let label = value.edition_type.abbreviation + ' ' + value.number

  if (value.suplement === 1 || value.suplement === '1') {
    label = label + ' Sup.'
  }

  return label + ' - ' + moment(String(value.publication_date)).format('DD/MM/Y')
}

Vue.mixin({
  filters: {
    formatDate,
    formateDateLong,
    formatEdition,
    formatEditionAbreviation,
    returnBoolean
  },
  methods: {
    getEditionStatusBadge,
    translateEditionStatusBadge
  }
})
